<vwui-table [compactable]="false">
    <div slot="table-title" class="table-title">
        {{ 'PROJECT_ATTACHMENTS.title' | translate }}
    </div>
    <vwui-pagination
        slot="table-pagination"
        [totalItems]="page?.totalElements"
        [totalPages]="page?.totalPages"
        [currentPage]="(page?.number ?? 0) + 1"
        [firstItem]="firstItem()"
        [lastItem]="lastItem()"
        (vwuiPaginationChange)="setPage($event.detail)"
    ></vwui-pagination>
    <div slot="table-action" class="table-action">
        <input #fileInput type="file" hidden [attr.accept]="getSupportedExtensions()" (change)="onFileSelected($event)" />
        <vwui-button
            class="is-secondary"
            [disabled]="isUploading"
            [loading]="isUploading"
            [ariaLabel]="'PROJECT_ATTACHMENTS.button.upload' | translate"
            (click)="fileInput.click()"
        >
            {{ 'BUTTON.create' | translate }}
        </vwui-button>
    </div>

    <div class="rows-scroll">
        <div class="rows-table">
            @if (isLoading) {
                <vwui-table-row>
                    <vwui-spinner></vwui-spinner>
                </vwui-table-row>
            } @else if (attachments.length === 0) {
                <vwui-table-row>
                    <div class="empty-state">{{ 'PROJECT_ATTACHMENTS.empty' | translate }}</div>
                </vwui-table-row>
            } @else {
                @for (attachment of attachments; track trackAttachment($index, attachment)) {
                    <vwui-table-row>
                        <vwui-table-column>{{ attachment.originalFileName }}</vwui-table-column>
                        <vwui-table-column class="actions">
                            <div class="row-actions">
                                <vwui-tooltip [label]="'PROJECT_ATTACHMENTS.button.download' | translate">
                                    <button
                                        type="button"
                                        class="icon-button"
                                        [attr.aria-label]="'PROJECT_ATTACHMENTS.button.download' | translate"
                                        (click)="download(attachment)"
                                    >
                                        <vwui-icon iconName="vwui-download"></vwui-icon>
                                    </button>
                                </vwui-tooltip>
                                <vwui-tooltip [label]="'PROJECT_ATTACHMENTS.button.delete' | translate">
                                    <button
                                        type="button"
                                        class="icon-button icon-button--danger"
                                        [disabled]="deletingUuid === attachment.uniqueId"
                                        [attr.aria-label]="'PROJECT_ATTACHMENTS.button.delete' | translate"
                                        (click)="deleteAttachment(attachment)"
                                    >
                                        <vwui-icon iconName="vwui-trash"></vwui-icon>
                                    </button>
                                </vwui-tooltip>
                            </div>
                        </vwui-table-column>
                    </vwui-table-row>
                }
            }
        </div>
    </div>
</vwui-table>
@if (!isLoading && attachments.length !== 0) {
    <div class="download-all">
        <vwui-button (click)="downloadAll()" [loading]="isDownloadingAll" class="is-secondary">
            {{ 'PROJECT_ATTACHMENTS.button.download_all' | translate }}
        </vwui-button>
    </div>
}
